"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.userGroup.list': 'Gruppi di Utenti',
    'route.userGroup.create': 'Aggiungi Gruppo di Utenti',
    'route.userGroup.edit': 'Modifica Gruppo di Utenti',
};
